/* eslint-disable no-restricted-globals */
import { Link, Navigate, useNavigate } from "react-router-dom";
import InputField from "../../components/inputField/inputField";
import PrimaryBtn from "../../components/primaryButton/primaryBtn";
import { useContext, useState } from "react";
import { LOGIN_URL } from "../../global/API";
import Cookies from "js-cookie";
import AuthLayout from "../../components/authLayout/authLayout";
import { AuthContext } from "../../context/AuthContext/AuthContext";

const SignIn = () => {
  const [userDetails, setUserDetails] = useState({ email: "", password: "" });
  const [errorMsg, setErrorMsg] = useState({ emailError: "", passwordError: "", formError: "" });
  const [showPassword, setShowPassword] = useState(false);
  const { setUser } = useContext(AuthContext);

  const navigate = useNavigate();

  const getUserEmail = (event) => {
    setUserDetails({ ...userDetails, email: event.target.value });
    setErrorMsg({ ...errorMsg, emailError: "" });
  };

  const getUserPassword = (event) => {
    setUserDetails({ ...userDetails, password: event.target.value });
    setErrorMsg({ ...errorMsg, passwordError: "" });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const formElement = document.getElementById("authLogin");
    const formData = new FormData(formElement);
    const options = {
      method: "POST",
      body: formData,
    };
    const response = await fetch(LOGIN_URL, options);
    const data = await response.json();

    if (data.status === "Success") {
      Cookies.set("jwtToken", data.token, { expires: 1 });
      setUser(data.user);
      // ✅ store user data & phone in localStorage
      localStorage.setItem("userData", JSON.stringify(data.user));
      window.open("https://alicepare.api.ayatasgroup.com/clio/redirect", "_blank");
      navigate("/", { replace: true });
    }

    if (data.success === false) {
      setErrorMsg({
        emailError: data.message.email !== undefined ? data.message.email[0] : "",
        passwordError: data.message.password !== undefined ? data.message.password[0] : "",
        formError: data.message.email === undefined && data.message.password === undefined ? data.message : "",
      });
    }
  };

  const renderItem = () => {
    return (
      <form id="authLogin">
        <img className="logo" src="/assets/images/logo.png" alt="" />
        <h2>Log in to your account</h2>
        <div className="form-group">
          <label>Email</label>
          <InputField name="email" className="form-control" type="email" onChange={getUserEmail} value={userDetails.email} />
          {errorMsg.emailError !== "" && <p className="error-msg">{errorMsg.emailError}</p>}
        </div>
        <div className="form-group">
          <label>
            Password <a href=" ">Forgot your password?</a>
          </label>
          <div className="selected-input">
            <InputField name="password" type={showPassword ? "text" : "password"} onChange={getUserPassword} value={userDetails.password} />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className={showPassword ? "ri-eye-line" : "ri-eye-off-line"}></button>
          </div>
          {errorMsg.passwordError !== "" && <p className="error-msg">{errorMsg.passwordError}</p>}
        </div>
        <PrimaryBtn type="submit" submitBtn={onSubmit}>
          Sign In
        </PrimaryBtn>
        {errorMsg.formError !== "" && <p className="error-msg">{errorMsg.formError}</p>}
        <p className="small">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </p>
        {/* 
        <p className="mt-3 fw-semibold no-span">OR sign with</p>

        <div className="text-center">
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="bx bxl-google fs-20"></i>
          </a>
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="ri-facebook-fill fs-20"></i>
          </a>
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="bx bxl-github fs-20"></i>
          </a>
        </div> */}
      </form>
    );
  };

  const jwtToken = Cookies.get("jwtToken");
  if (jwtToken !== undefined) {
    return <Navigate to="/" replace />;
  } else {
    return <AuthLayout renderItem={renderItem} />;
  }
};

export default SignIn;
